import { Button, Stack } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import { Calendar, RotateCw, Share2, Users } from "lucide-react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ActivitiesFiltersItem } from "web_myplann/Activities/Filters/Components/ActivitiesFiltersItem";
import { formatDateRange } from "web_myplann/Activities/Filters/Helpers/formatDateRange";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import {
	activitiesFiltersState,
	defaultActivitiesFiltersState,
} from "web_myplann/Shared/State/activitiesFiltersAtom";
import { DEFAULT_ROUTE } from "web_myplann/Utils/constants";
import { allActivityCreated } from "web_myplann/Utils/types";

export const ActivitiesFiltersListPage = () => {
	const { t } = useResource();
	const navigate = useNavigate();

	const handleFilter = () => {
		navigate(-1);
	};

	const { dateFrom, dateTo, types, created } = useAtomValue(
		activitiesFiltersState,
	);
	const setFiltersState = useSetAtom(activitiesFiltersState);

	const termFormatted = useMemo(
		() => formatDateRange(dateFrom, dateTo),
		[dateFrom, dateTo],
	);

	const typeFormatted = useMemo(() => types.join(", "), [types]);

	const createdFormatted = useMemo(() => {
		if (created.length === allActivityCreated.length) {
			return t(Resources.Activity.Filters.Created.All);
		}

		return created.join(", ");
	}, [created]);

	const handleReset = () => setFiltersState(defaultActivitiesFiltersState);

	return (
		<MyPlannLayout
			topBar={
				<NavigationHeader
					title={t(Resources.Activity.Filters.title)}
					defaultRoute={DEFAULT_ROUTE}
					endComponent={<RotateCw size={16} onClick={handleReset} />}
				/>
			}
		>
			<Stack paddingTop={1.6}>
				<ActivitiesFiltersItem
					icon={<Calendar />}
					label={t(Resources.Activity.Filters.Term.title)}
					text={termFormatted}
					onClick={() => {
						navigate(Routing.ActivitiesFiltersDate.path());
					}}
				/>
				<ActivitiesFiltersItem
					icon={<Share2 />}
					label={t(Resources.Activity.Filters.Type.title)}
					text={typeFormatted}
					onClick={() => {
						navigate(Routing.ActivitiesFiltersType.path());
					}}
				/>
				<ActivitiesFiltersItem
					icon={<Users />}
					label={t(Resources.Activity.Filters.Created.title)}
					text={createdFormatted}
					hideDivider
					onClick={() => {
						navigate(Routing.ActivitiesFiltersCreated.path());
					}}
				/>
				<Button
					variant="contained"
					color="primary"
					type="button"
					fullWidth
					onClick={handleFilter}
					sx={{ marginTop: "8px" }}
				>
					{t(Resources.Common.Filter)}
				</Button>
			</Stack>
		</MyPlannLayout>
	);
};
